export default __webpack_public_path__ + "static/media/additional_stop.80276536.svg";